/**
 * Admin\Report Feedback: the in-app Report Feedback panel (intent report-feedback, ADR-2).
 *
 * Net new, with no legacy equivalent. Grant only to CCT staff roles in CCT-operated environments.
 * Whether the feature is available at all is a separate gate (the availability route, ADR-4); these
 * commands decide who may use it where it is available. Both are enforced server-side.
 */

import { admin } from './admin';

export const reportFeedback = admin.tool('Report Feedback');
export const reportFeedbackSubmit = reportFeedback.command('Submit Feedback');
export const reportFeedbackView = reportFeedback.command('View My Feedback');
